export function Slogan(){
    let is_standard = true
    is_standard = false
    return <div>
        {/*<input type="text" is_standart? 'pattern={2w 2n 3w}' : '' maxLength={20}/>*/}
        <div className={'item'}>
            <input type="radio" data-type={""} data-color={"red"} data-plate_type={"Car"}/>
        </div>
    </div>
}